const UitkIconThemeMap = [
  ["default", ""],
  ["positive", "uitk-icon-positive-theme"],
  ["negative", "uitk-icon-negative-theme"],
  ["warning", "uitk-icon-warning-theme"],
  ["informative", "uitk-icon-informative-theme"]
];
export const UitkIconThemes = new Map(UitkIconThemeMap);
const UitkIconSpotlightMap = [
  ["background", "spotlight-background"],
  ["transparent", "spotlight-transparent"]
];
export const UitkIconSpotlights = new Map(UitkIconSpotlightMap);
